(function ($) {

'use strict';

	/**
	 * Loads the jquery.lightbox_me.js if required and execute the done function
	 * when ready
	 * @param {function} doneFunc
	 * @returns {undefined}
	 */
	$.loadLightboxJs = function (doneFunc) {

		/**
		 * check if the doneFunc could run
		 */
		function loadedNow() {
			if (!$.loadLightboxActive) {
				doneFunc();
			} else {
				setTimeout(loadedNow, 100);
			}
		}

		if (typeof $.fn.lightbox_me !== 'function' && !$.loadLightboxActive) {
			// set loading status
			$.loadLightboxActive = true;
			// try to load jquery.lightbox_me.js
			var jsFile = '/js/jquery.lightbox_me.js';
			$.cachedScript(jsFile).done(function () {
				// clear loading status

				delete $.loadLightboxActive;
				
				/**
				 * start a lightbox
				 * @param {jQuery | string} $markup
				 * @param {type} options to call lightbox_me(options)
				 * @returns {jQuery}
				 */
				$.fn.lightbox_me_start = function ($markup, options, includeCloseButton = true, lockScroll = true) {
					var $lightboxElem = $(this);
					
					options = $.extend({
						centered: true,
						zIndex: 9999,
						destroyOnClose: true
					}, options || {});
					
					// store the original callbacks
					var callbacks = {
						onLoad: options.onLoad,
						onClose: options.onClose
					};

					options.onLoad = function() {
						if(lockScroll){
							$('body').addClass('lb_noscroll');
						}
						
						if (typeof callbacks.onLoad === 'function') {
							callbacks.onLoad();
						}
					};
					options.onClose = function() {
						$lightboxElem.remove();
						$('body').removeClass('lb_noscroll');
						
						if (typeof callbacks.onClose === 'function') {
							callbacks.onClose();
						}
					};
					
					if(includeCloseButton === true){
						$lightboxElem.append('<div class="close lightbox-close-info ed_alignright">'
								+ $.i81n.text('CLOSE')
								+ '<span class="lightbox-close-x"> &#x2715; </span></div>');
					}
					
					$lightboxElem.append($markup)
						.lightbox_me(options);
				
					return this;
				};
				
				if (typeof doneFunc === 'function') {
					doneFunc();
				}
			}).fail(function (jqxhr, settings, exception) {
				console.log(jsFile + ' ! ' + exception);
			});
		} else if (typeof doneFunc === 'function') {
			loadedNow();
		}
	};	// $.loadLightboxJs

}(jQuery));